import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";
import {USER_TYPES} from "../../constants";

const Footer = () => {
  const { userData, isUserAuthorized } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility }  = useContext(FooterContext);

  // const routeReturn = () => {
  //   if(isUserAuthorized && userData && userData.ref_type ) {
  //     if (USER_TYPES.AREA_USER.includes(userData.ref_type)){
  //         console.log(USER_TYPES.AREA_USER.includes(userData.ref_type),"USER_TYPES.AREA_USER.includes(userData.ref_type)")
  //       return `/idp_territories` 
  //     }
  //     else if (USER_TYPES.MANAGER.includes(userData.ref_type) ){
  //       console.log(USER_TYPES.MANAGER.includes(userData.ref_type),"USER_TYPES.MANAGER.includes(userData.ref_type)")
  //       return '/statistics' 
  //     } else {
  //       return '/cases'
  //     }
  //   }else{
  //     return `/users/sign_in`
  //   }
  // }

  return (
      <footer className="footer-policy">
        <div className="container-fluid bg-primary">
          <div className="links">

          {/* <Link to={{
              pathname: routeReturn(),
            }}
            reloadDocument
             >
>>>>>>> Stashed changes */}
           
            <Link
                to={
                  isUserAuthorized && userData
                      ? USER_TYPES.AREA_USER.includes(userData.ref_type)
                          ? "/idp_territories"
                          : USER_TYPES.MANAGER.includes(userData.ref_type)
                              ? "/statistics"
                              : "/cases"
                      : "/users/sign_in"
                }
            >
              Home
            </Link>

            <a href="https://ferringusa.com/privacy/" target="_blank" rel="noreferrer">Privacy Policy</a>
            <a href="/" target="_blank">Legal Disclaimer</a>
            <a href="mailto:suggestions@cmcopilot.com">Suggestions</a>
          </div>
        </div>
        <div className="accordion" id="accordionExample">
          <h2 className="accordion-header">
            <button
                onClick={changeAccordianVisibility}
                className="accordion-button collapsed text-uppercase Hub-Footer-link fw-normal fs-5
                  rounded-0
                  "
                type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
            >
              PLEASE SEE IMPORTANT SAFETY INFORMATION AND FULL PRESCRIBING INFORMATION
              {isAccordianShown ? (
                  <i className="bi bi-chevron-down ps-1"></i>
              ) : (
                  <i className="bi bi-chevron-up ps-1"></i>
              )}
            </button>
          </h2>
          <div id="collapseOne" className={`accordion-collapse collapse ${isAccordianShown ? 'show' : ''}`}
               data-bs-parent="#accordionExample">
            <h2 className="text-primary pt-3">Indication</h2>
            <p>EUFLEXXA<sup>®</sup> (1% sodium hyaluronate) is indicated for the treatment of pain in
              osteoarthritis
              (OA) of the knee in patients who have failed to respond adequately to conservative nonpharmacologic
              therapy and simple analgesics (eg, acetaminophen).
            </p>
            <h2 className="text-primary">Important Safety Information</h2>
            <p>EUFLEXXA is contraindicated in patients who have a known hypersensitivity to hyaluronate preparations
              or who have knee joint infections, infections, or skin disease in the area of the injection site.</p>
            <p>EUFLEXXA should not be administered through a needle previously used with medical solutions containing
              benzalkonium chloride. Do not use skin disinfectants for skin preparation that contain quaternary
              ammonium salts.</p>
            <p>Do not inject intravascularly due to potential for systemic adverse events.</p>
            <p>The safety and effectiveness of injection in conjunction with other intra-articular injectables, or
              into joints other than the knee have not been studied. Remove any joint effusion prior to injecting.
              Transient pain or swelling of the injected joint may occur after intra-articular injection with
              EUFLEXXA.</p>
            <p>The most common adverse events related to EUFLEXXA injections reported in 12- and 26-week clinical
              studies were arthralgia, back pain, pain in extremity, musculoskeletal pain, and joint swelling. In an
              open-label extension of the 26-week clinical study with repeat series of injections, the most common
              adverse events related to EUFLEXXA at Week 52 were arthralgia and joint swelling.</p>
            <p>
              <a target="_blank" className="text-decoration-none" href="http://www.ferringusa.com/pi/euflexxa">
                <strong>Please see full prescribing information.</strong>
              </a>
            </p>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
